<template>
  <nav class="navbar footer-nav" style="background: transparent">
    <div class="navbar-item footer-logo-left">
      <a class="logo-wrapper" href="https://www.ethz.ch" target="_blank">
        <img class="image" src="./../assets/logos/eth.svg" alt="ETH Logo" />
      </a>
    </div>
    <div class="footer-links">
      <div class="navbar-item">
        <a
          class="external-link"
          href="https://kof.ethz.ch/en/footer/disclaimer-copyright.html"
          @click="trackOutgoing"
          target="_blank"
          >Disclaimer & Copyright</a
        >
      </div>
      <div class="navbar-item">
        <a
          class="external-link"
          href="https://kof.ethz.ch/en/footer/data-protection.html"
          @click="trackOutgoing"
          target="_blank"
          >Data Protection</a
        >
      </div>
      <div class="navbar-item">
        <theme-toggle />
      </div>
    </div>
    <div class="navbar-item footer-logo-right">
      <a class="logo-wrapper" href="https://kof.ethz.ch" target="_blank">
        <img
          class="image kof-image"
          src="./../assets/logos/kof.svg"
          alt="KOF Logo"
        />
      </a>
    </div>
  </nav>
</template>

<script>
import { usePlausible } from "v-plausible/vue";
import ThemeToggle from "@/components/ThemeToggle.vue";

export default {
  name: "NclFooter",
  components: {
    ThemeToggle,
  },
  setup() {
    const { trackEvent } = usePlausible();
    return { trackEvent };
  },
  methods: {
    trackOutgoing: function (e) {
      this.trackEvent("Outbound Link: Click", {
        props: { url: e.target.href },
      });
    },
  },
};
</script>

<style scoped>
.footer-nav {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  padding: 1rem;
}

.footer-links {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  gap: 0.75rem 1.25rem;
  flex: 1;
}

a.external-link {
  color: rgba(var(--v-theme-on-surface), 0.7);
  cursor: pointer;
}

a.external-link:hover {
  color: rgb(var(--v-theme-on-surface));
}

.logo-wrapper {
  display: inline-flex;
  align-items: center;
  background: #fff;
  padding: 6px 10px;
  border-radius: 4px;
}

.footer-nav .image {
  height: 32px;
  width: auto;
  display: block;
}

.footer-nav .kof-image {
  height: 28px;
}

@media (min-width: 769px) and (max-width: 1100px) {
  .footer-nav {
    flex-wrap: nowrap;
    gap: 0.75rem;
    padding: 0.75rem;
  }

  .footer-links {
    flex-wrap: nowrap;
    gap: 0.5rem 0.75rem;
    font-size: 0.9rem;
  }

  .footer-nav .image {
    height: 26px;
  }

  .footer-nav .kof-image {
    height: 22px;
  }

  .logo-wrapper {
    padding: 4px 8px;
  }
}

@media (max-width: 768px) {
  .footer-nav {
    text-align: center;
    gap: 1rem;
    padding: 1rem 0.75rem;
  }

  .footer-links {
    order: -1;
    flex-basis: 100%;
    width: 100%;
    gap: 0.5rem 1rem;
  }

  .footer-logo-left,
  .footer-logo-right {
    flex: 0 0 auto;
  }

  .footer-nav .image {
    height: 28px;
  }

  .footer-nav .kof-image {
    height: 24px;
  }
}
</style>
